import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';


const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': '',
        'Accept': 'application/json'
    })
};

@Injectable({
    providedIn: 'root'
})

export class NavigationService {
}
